import axios from 'axios';
import {ENDPOINT} from 'constants';

const BASE_URL = `${ENDPOINT}api/v1/admin-ops/env-variables`;

const authHeaders = accessToken => ({
  headers: {Authorization: `Bearer ${accessToken}`},
});

// Secrets manager — this module never logs `currentValue`/`value` and never
// puts them in query params. Values only ever travel in request/response bodies.
export const envVariablesApi = {
  fetchVariables: async (accessToken, params = {}) => {
    const {data} = await axios.get(BASE_URL, {
      ...authHeaders(accessToken),
      params,
    });
    return data?.data;
  },

  createVariable: async (accessToken, payload) => {
    const {data} = await axios.post(BASE_URL, payload, authHeaders(accessToken));
    return data?.data;
  },

  updateValue: async (accessToken, id, value) => {
    const {data} = await axios.patch(`${BASE_URL}/${id}`, {value}, authHeaders(accessToken));
    return data?.data;
  },

  reveal: async (accessToken, id) => {
    const {data} = await axios.post(`${BASE_URL}/${id}/reveal`, null, authHeaders(accessToken));
    return data?.data;
  },

  setLocked: async (accessToken, id, isLocked) => {
    const {data} = await axios.patch(`${BASE_URL}/${id}/lock`, {isLocked}, authHeaders(accessToken));
    return data?.data;
  },
};
